module.exports = "/wwwroot/img/one_column_content_block.png?ver=8aa83f28";